/* global angular */

angular.module ('atex.aceui.service')
  .factory ('CognitoService', ['ApplicationConfigurationService', 'AuthenticationService',
    (ApplicationConfigurationService, AuthenticationService) => {
      let service;
      const getService = () => {
        service = service || ApplicationConfigurationService.getServiceConfigurationFor ('CognitoService')
          .then ((configuration) => {
            let serviceUrl = atex.aceui.ServiceUtils.calculateServiceUrl (configuration);
            return atex.aceui.service.CognitoService (serviceUrl);
          });
        return service;
      };

      return {
        info: () => {
          return getService ()
            .then ((CognitoService) => {
              return AuthenticationService.callWithAuthentication (({ token }) => { 
                return CognitoService.info ({ token });
              });
            });
        },

        inviteUser: ({ username, email }) => {
          return getService ()
            .then ((CognitoService) => {
              return AuthenticationService.callWithAuthentication (({ token }) => {
                return CognitoService.inviteUser ({ username, email, token });
              });
            });
        },

        enableUser: ({ username }) => {
          return getService ()
            .then ((CognitoService) => {
              return AuthenticationService.callWithAuthentication (({ token }) => {
                return CognitoService.enableUser ({ username, token });
              });
            });
        },

        disableUser: ({ username }) => {
          return getService ()
            .then ((CognitoService) => {
              return AuthenticationService.callWithAuthentication (({ token }) => {
                return CognitoService.disableUser ({ username, token });
              });
            });
        }
      };
    }]);
